import React, { FC, useEffect, useState } from "react";
import { Button } from "components/shared";
import { ReactComponent as FiltrationTickIcon } from "images/FiltrationTickIcon.svg";
import { ReactComponent as BackArrowIcon } from "images/back-arrow.svg";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import Search from "components-new/Search";
import { Folders } from "./Folders/Folders";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { UploadingDocument } from "./Folders/UploadingDocument/UploadingDocument";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import styles from "./DocumentsPage.module.sass";
import cn from "classnames";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { AddingFolder } from "./Folders/AddingFolder/AddingFolder";
import { Categorization } from "./Categorization/Categorization";
import { ChangeSearchValue } from "toolkit/documents/documents.slice";
import { getDocumentOrganization } from "toolkit/documents/documents.thunks";
import Badge from "components-new/Badge";
import { changeDetaildeMode } from "toolkit/documents/categorization/categorization.slice";

interface IModalWindow {
	content: React.ReactElement | null;
	visibility: boolean;
}

export const DocumentsPage: FC = () => {
	const { condition, organizationId, folderId, mode } = useParams();
	const navigate = useNavigate();
	const { documentOrganization, searchValue } = useAppSelector((state) => state.documents);
	const { currentTab, detailedMode } = useAppSelector((state) => state.categorization);
	const [modalWindow, setModalWindow] = useState<IModalWindow>({
		content: null,
		visibility: false,
	});
	const { state } = useLocation();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(getDocumentOrganization({ organizationId: Number(organizationId) }));
		//eslint-disable-next-line
	}, [organizationId]);

	const openModalWindow = (component: React.ReactElement) => {
		setModalWindow({ ...modalWindow, content: component, visibility: true });
	};

	const closeModalWindow = () => {
		setModalWindow({ ...modalWindow, content: null, visibility: false });
	};

	const backClickHandler = () => {
		if (detailedMode) dispatch(changeDetaildeMode(false));
		else navigate(-1);
	};

	return (
		<main className={styles.content}>
			{modalWindow.visibility && (
				<ModalWindow close={closeModalWindow} scroll={false}>
					{modalWindow.content}
				</ModalWindow>
			)}
			<section className={cn(styles.documents)}>
				{/* <section className={cn(styles.documents, styles.noScroll)}> */}
				<div className={styles.header}>
					<div className={styles["header-titles-wrp"]}>
						<div onClick={backClickHandler} className={styles.backIcon}>
							<BackArrowIcon />
						</div>
						<div className={styles["header-titles"]}>
							<span className={styles.subtitle}>{documentOrganization?.fullName}</span>
							{/* <span className={styles.title}>{ condition === "current" ? "Документы" : "Архив документов" }</span> */}
							<span className={styles.title}>
								Документы
								{condition === "archive" && <Badge color="#7CADAA">Архив</Badge>}
							</span>
							{folderId && <span className={styles.subtitle}>{state?.folderName}</span>}
						</div>
					</div>
					<div className={styles["header-item"]}>
						<div className={styles["filtration-wrp"]}>
							<button className={styles["filtration-btn"]}>
								<span className={styles["filtration-name"]}>
									{mode === "folders" ? "Документы организации" : "Документы категорирования"}
								</span>
								<FiltrationTickIcon />
							</button>
							<div className={styles.filtration}>
								<Link to={`/documents/${condition}/${organizationId}/folders`}>
									<button className={styles["filtration-item"]}>Документы организации</button>
								</Link>
								<Link to={`/documents/${condition}/${organizationId}/categorization/order`}>
									<button className={styles["filtration-item"]}>Документы категорирования</button>
								</Link>
							</div>
						</div>
						{(folderId || mode === "categorization") && (
							<div>
								<Search
									className={styles.search}
									searchValue={searchValue}
									handleSearch={(e) => dispatch(ChangeSearchValue(e.target.value))}
								/>
							</div>
						)}
						{condition === "current" && (
							<div
								className={cn(
									mode === "categorization" && currentTab !== "ENUM" && currentTab !== "RESULT" && styles.disabled,
								)}>
								<Link
									to={`/documents/archive/${organizationId}/${mode}${folderId ? `/${folderId}` : ""}`}
									state={{ folderName: state?.folderName }}>
									<Button
										disabled={mode === "categorization" && currentTab !== "ENUM" && currentTab !== "RESULT"}
										variant={BUTTON_VARIANTS.OUTLINED}>
										Перейти в архив
									</Button>
								</Link>
							</div>
						)}
						{!folderId && mode === "folders" && (
							<div>
								<Button
									disabled={condition !== "current" || documentOrganization?.archived}
									onClick={() => openModalWindow(<AddingFolder title="Создание папки" close={closeModalWindow} />)}>
									Создать папку
								</Button>
							</div>
						)}
						{folderId && mode === "folders" && condition === "current" && (
							<div>
								<Button
									disabled={documentOrganization?.archived}
									onClick={() => openModalWindow(<UploadingDocument close={closeModalWindow} />)}>
									Загрузить документ
								</Button>
							</div>
						)}
					</div>
				</div>
				{mode === "folders" ? <Folders /> : <Categorization />}
			</section>
		</main>
	);
};
